import { z } from "zod";

export const cxFeatureFlagsSchema = z.object({
  shouldShowLegacyDashV1: z.literal(true).optional(),
});
export type CxFeatureFlags = z.infer<typeof cxFeatureFlagsSchema>;
